import { UserOutlined } from '@ant-design/icons';
import { App, Button, Form, Input, Modal, Pagination, Table, Tag } from 'antd';
import { SITE } from 'config/config';
import dayjs from 'dayjs';
import { useState } from 'react';
import { claimReward, historyPredictions } from 'service/base';
import 'styles/global.css';

const HistoryPredictions = ({ isModalVote, setIsModalVote, IP, FP }) => {
  const { notification } = App.useApp();
  const [formHistory] = Form.useForm();
  const [account, setAccount] = useState('');
  const [dataPrediction, setDataPrediction] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 15
    }
  });
  const [pagination, setPagination] = useState({
    current: tableParams.pagination.current || 1,
    pageSize: tableParams.pagination.pageSize || 15,
    total: dataPrediction?.totalRecords || 0,
    size: 'default',
    onChange: (page, pageSize) => {
      console.log('Page change:', page, pageSize);
      setPagination({ ...pagination, current: page });
    }
  });

  const handleCancelVote = () => {
    setIsModalVote(false);
  };
  const onFinishHistoryForm = async (data) => {
    try {
      const normalizedAccount = String(data?.account ?? account ?? '')
        .trim()
        .toLowerCase();
      if (!normalizedAccount) {
        notification.warning({
          message: 'Cảnh báo',
          description: 'Vui lòng nhập tên đang nhập!'
        });
        return;
      }
      const confirmed = window.confirm(
        'Để đảm bảo tính bảo mật, chúng tôi sẽ sử dụng những dự đoán trước đó dựa trên địa chỉ IP bạn đã truy cập để cung cấp thông tin dự đoán.'
      );
      if (!confirmed) {
        return;
      }
      setAccount(normalizedAccount);
      data.account = normalizedAccount;
      setIsLoadingSubmit(true);
      data.site = SITE;
      data.ip = IP;
      data.fp = FP;
      const res = await historyPredictions(data);
      setDataPrediction(res?.data || []);
      if (!res?.data?.listPrediction[0]) {
        notification.warning({
          message: 'Không có lịch sử',
          description: 'Không tìm thấy lịch sử bình chọn, Quý khách vui lòng kiểm tra lại!'
        });
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      setIsLoadingSubmit(false);
    }
  };

  const onFinishHistoryFailed = () => {
    notification.warning({
      message: 'Cảnh báo',
      description: 'Vui lòng kiểm tra lại tài khoản !'
    });
  };

  const handleClaimReward = async (item) => {
    if (item.status_register !== 'apply') {
      return;
    }
    try {
      const itemAccount = String(item?.account ?? '')
        .trim()
        .toLowerCase();
      const formAccount = String(formHistory.getFieldValue('account') ?? '')
        .trim()
        .toLowerCase();
      const stateAccount = String(account ?? '')
        .trim()
        .toLowerCase();
      const accountValue = itemAccount || formAccount || stateAccount;
      if (!accountValue) {
        notification.warning({
          message: 'Thiếu tài khoản',
          description: 'Không xác định được tài khoản để nhận thưởng.'
        });
        return;
      }
      const response = await claimReward({
        account: accountValue,
        site: SITE,
        matchId: item.matchId
      });
      if (response?.code === 0) {
        notification.success({ message: 'Thành công', description: 'Nhận thưởng thành công!' });
        const res = await historyPredictions({
          account: accountValue,
          site: SITE,
          ip: IP,
          fp: FP
        });
        setDataPrediction(res?.data || []);
      }
    } catch (error) {
      notification.error({
        message: 'Nhận thưởng thất bại!',
        description: error.message
      });
    }
  };

  const columns = [
    {
      title: 'Trận đấu',
      render: (_, record) => {
        return record.homeName + ' - ' + record.awayName;
      }
    },
    {
      title: 'Bình chọn',
      width: '15%',
      render: (_, record) => {
        return (
          <Tag className="text-center" color="#000000" key={record._id}>
            {record.homeScore}-{record.awayScore}
          </Tag>
        );
      }
    },
    {
      title: 'Lượt dự đoán',
      width: '12%',
      render: (_, record) => {
        return (
          <Tag className="text-center" color="#000000" key={record._id}>
            {record.sameScore}
          </Tag>
        );
      }
    },
    {
      title: 'Kết quả',
      width: '10%',
      render: (text, record) => {
        if (record.match_result) {
          return (
            <Tag className="text-center" color="#00890a" key={record._id}>
              {record.match_result}
            </Tag>
          );
        } else {
          return null;
        }
      }
    },
    {
      title: 'Điểm thưởng',
      width: '10%',
      render: (_, record) => (record.point > 0 ? record.point : '-')
    },
    {
      title: 'Nhận thưởng',
      width: '16%',
      render: (_, item) => (
        <div className="flex justify-start">
          <button
            type="button"
            onClick={() => handleClaimReward(item)}
            disabled={item.status_register !== 'apply'}
            className={`rounded-md border-none px-1 py-2 text-xs font-semibold text-white md:rounded-lg md:px-3 md:text-sm ${item.status_register === 'apply' ? 'cursor-pointer bg-[#1677ff]' : 'cursor-not-allowed bg-[#929292]'}`}
          >
            {item.status_register === 'accept' ? 'Đã nhận thưởng' : 'Nhận thưởng'}
          </button>
        </div>
      )
    },
    {
      title: 'Ngày dự đoán',
      dataIndex: 'createdAt',
      render: (_, record) => dayjs(_).format('DD/MM/YYYY')
    }
  ];

  const predictionRows = dataPrediction?.responseData || [];
  const totalRecords = dataPrediction?.totalRecords ?? predictionRows.length;
  const currentPage = pagination.current || 1;
  const pageSize = pagination.pageSize || 15;
  const mobileStart = (currentPage - 1) * pageSize;
  const mobileRows = predictionRows.slice(mobileStart, mobileStart + pageSize);

  return (
    <Modal
      className="modal-jun88k36 modal-history"
      title="DANH SÁCH LỊCH SỬ DỰ ĐOÁN"
      open={isModalVote}
      footer={null}
      onCancel={handleCancelVote}
    >
      <div className="content-km content-history">
        <Form
          name="formHistoryMatch"
          onFinish={onFinishHistoryForm}
          onFinishFailed={onFinishHistoryFailed}
          onValuesChange={(_, allValues) => {
            setAccount(String(allValues?.account ?? '').trim());
          }}
          className="relative"
          autoComplete="off"
          form={formHistory}
          initialValues={{ account: account }}
        >
          <div className="flex md:justify-center justify-between gap-2 md:py-4 py-1 w-full relative">
            <Form.Item
              name="account"
              className="mb-0 min-w-[30%] md:min-h-[38px] w-full max-w-[600px]"
              rules={[
                {
                  required: true,
                  whitespace: true,
                  message: 'Vui lòng điền tên đăng nhập!'
                }
              ]}
            >
              <Input
                className="min-h-[38px] w-full"
                placeholder="Nhập tên đăng nhập ..."
                maxLength={30}
                prefix={<UserOutlined />}
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoadingSubmit}
              className="bg-score bg-check-account text-white font-medium min-h-[32px] absolute right-3 top-[50%] translate-y-[-50%] z-30"
            >
              Xác Nhận
            </Button>
          </div>
        </Form>
        <div className="list-history">
          <div className="hidden md:block overflow-x-auto">
            <Table
              size="small"
              columns={columns}
              dataSource={predictionRows}
              loading={isLoadingSubmit}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: totalRecords,
                size: 'default',
                onChange: (page, nextPageSize) => {
                  setPagination((prev) => ({
                    ...prev,
                    current: page,
                    pageSize: nextPageSize || prev.pageSize
                  }));
                }
              }}
              scroll={{ x: 'max-content' }}
            />
          </div>

          <div className="md:hidden space-y-2">
            {mobileRows.map((item) => (
              <div
                key={item._id ?? `${item.matchId}-${item.account}`}
                className="rounded-lg border border-[#E5E7EB] bg-[#e9f1ff] rounded-[16px] p-3"
              >
                <div className="font-semibold text-[14px] mb-2">
                  {item.homeName} - {item.awayName}
                </div>
                <div className="flex flex-wrap gap-2">
                  <Tag color="#000000" style={{ fontSize: 13, lineHeight: '20px' }}>
                    Bình chọn: {item.homeScore}-{item.awayScore}
                  </Tag>
                  <Tag color="#000000" style={{ fontSize: 13, lineHeight: '20px' }}>
                    Lượt dự đoán: {item.sameScore}
                  </Tag>
                  {item.match_result ? (
                    <Tag color="#00890a" style={{ fontSize: 13, lineHeight: '20px' }}>
                      KQ: {item.match_result}
                    </Tag>
                  ) : (
                    <Tag style={{ fontSize: 13, lineHeight: '20px' }}>Chờ KQ</Tag>
                  )}
                  <Tag color="#1677ff" style={{ fontSize: 13, lineHeight: '20px' }}>
                    Điểm: {item.point > 0 ? item.point : '-'}
                  </Tag>
                  <div className="mt-1 text-[12px] text-gray-500">
                    Ngày dự đoán: {dayjs(item.createdAt).format('DD/MM/YYYY')}
                  </div>
                </div>
                <div className="mt-3">
                  <button
                    type="button"
                    onClick={() => handleClaimReward(item)}
                    disabled={item.status_register !== 'apply'}
                    className={`rounded-md border-none px-3 py-2 text-xs font-semibold text-[13px] text-white ${item.status_register === 'apply' ? 'cursor-pointer bg-[#1677ff]' : 'cursor-not-allowed bg-[#929292]'}`}
                  >
                    {item.status_register === 'accept' ? 'Đã nhận thưởng' : 'Nhận thưởng'}
                  </button>
                </div>
              </div>
            ))}

            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalRecords}
              size="small"
              onChange={(page, nextPageSize) => {
                setPagination((prev) => ({
                  ...prev,
                  current: page,
                  pageSize: nextPageSize || prev.pageSize
                }));
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default HistoryPredictions;
